jQuery(function ($) {
	var like_options = {
		template: '<div class="like-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
		offset: '-6px',
		trigger : 'hover'
	}

	var rate_options = {
		template: '<div class="rate-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
		offset: '-2px',
		placement: 'bottom',
		trigger : 'hover'
	}

  $('[data-toggle="tooltip"]').each( function(e) {
  	$(this).tooltip(eval($(this).attr('data-options')))
  })
});